import React from 'react'
import ProfileBankRow from './ProfileBankRow'
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../library/layout/Index";

const ProfileBank = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)

    return (
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='Bank Details' />
                        </span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} id="newAddButton" ksc="b" rowKey="" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Bank" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <UiGridColTwo>
                    {
                            Object.values(viewData).map((row, index) => (
                                <ProfileBankRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            ))
                        }
                    </UiGridColTwo>
                </UiViewContent>
            </UiView>
    )
}

export default withView(ProfileBank, "proBank", "")